import React from 'react';
import { m } from 'framer-motion';
export function FinalCTA() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-57" data-mp="5dagpy4ywtot">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-58" data-mp="5bz3l7pmu9l1">
        <h2 className="font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-59" data-mp="3mua5xzvpibok">
          La decisión es tuya.
        </h2>

        <div className="mt-8 grid gap-4 text-left sm:grid-cols-2" data-id="element-60" data-mp="3rr0lmm3ln59g">
          <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="rounded-2xl border border-brown/20 bg-white p-6 shadow-card" data-id="element-61" data-mp="3ds0v18wj0gan">
            <p className="text-xs font-bold uppercase tracking-wide text-muted" data-id="element-62" data-mp="38usbp4zn667t">Opción A (la que conoces)</p>
            <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-63" data-mp="1242mo2y6t5cv">
              Puedes seguir viendo cómo tus herramientas cogen polvo, tus retales se van a la basura, y
              esperas a que suene el teléfono para una reforma pesada que no te pagan lo que vale.
            </p>
          </m.div>
          <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.08
        }} className="rounded-2xl border border-brown/30 bg-brown/5 p-6" data-id="element-64" data-mp="l90tgbgtbnp4">
            <p className="text-xs font-bold uppercase tracking-wide text-brown" data-id="element-65" data-mp="7bvj3za2g2o2">Opción B (la que queremos para ti)</p>
            <p className="mt-2 text-sm leading-relaxed text-ink" data-id="element-66" data-mp="gafv6hl4fe3b">
              Llegar al taller mañana con un plan. Fabricar tu primer soporte de laptop o tabla gourmet en
              40 minutos. Publicarlo antes de cenar. Venderlo al día siguiente.
            </p>
          </m.div>
        </div>

        <p className="mt-8 text-base leading-relaxed text-ink sm:text-lg" data-id="element-67" data-mp="1mqji0v7gxypt">
          El precio de dos menús del día. <span className="font-semibold text-brown" data-id="element-68" data-mp="kddh3wjwmrmz">El valor de tu nuevo negocio artesanal.</span>
        </p>
      </div>
    </section>;
}